<script setup>
import { onBeforeUnmount } from 'vue'

import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()

onBeforeUnmount(() => { webSiteStore.topBarHidden = false })
</script>

<template>
  <q-btn
    flat
    dense
    :icon="webSiteStore.topBarHidden ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'"
    :aria-label="webSiteStore.topBarHidden ? $t('common.showTopBar') : $t('common.hideTopBar')"
    @click="webSiteStore.topBarHidden = !webSiteStore.topBarHidden"
  />
</template>
